export default function ({ redirect, store, localePath, getRouteBaseName }) {
    if (store.state.auth.token && store.state.auth.user?.selected_company?.has_completed_registration) {
        if (/index/.test(getRouteBaseName())) {
            return redirect(localePath('/dashboard'));
        }
    }
}
